import {map} from 'lodash';

import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import AlleleFrequencyPopulation from 'pages/AlleleFrequency/population';
import {normalizeFrequency, uniquePopulations} from 'utils/frequencyUtils';

export default function AlleleFrequencyGene({id, population}) {
  const appContext = useAppContext();
  const {response, error} = useGet(`site/alleleFrequency/${id}`, {parseJson: true, cacheResponse: !appContext.isPreview});

  let body = <Loading />;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (response) {
    const frequencies = map(response.data, normalizeFrequency);
    const geneSymbol = frequencies[0].parent.symbol;

    const pops = uniquePopulations(frequencies);
    let defaultPop;
    if (pops?.length > 0 && !pops.includes('ALL')) {
      defaultPop = pops[0];
    }

    body = (
      <div>
        <h2>{geneSymbol}</h2>
        <AlleleFrequencyPopulation frequencies={frequencies} popProp={population || defaultPop} />
      </div>
    );
  }
  
  return body;
}
